import { render, staticRenderFns } from "./otherOrder.vue?vue&type=template&id=24fe23bf"
import script from "./otherOrder.vue?vue&type=script&lang=js"
export * from "./otherOrder.vue?vue&type=script&lang=js"
import style0 from "./otherOrder.vue?vue&type=style&index=0&id=24fe23bf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports